'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Business = void 0;
const $ = require("jquery");
require("slick-carousel");
class Business {
    constructor() {
        // 各スライダーを独立して初期化
        $('.bulletSceneSlider').each(function () {
            const $container = $(this); // 現在のスライダーコンテナ
            const $slider = $container.find('.bulletSceneSlide'); // スライダー本体
            const $prevButton = $container.find('.trigPrevScene'); // 前ボタン
            const $nextButton = $container.find('.trigNextScene'); // 次ボタン
            // Slickスライダーを初期化
            $slider.slick({
                arrows: false,
                infinite: false, // 無限ループを無効化
            });
            // ボタンの状態を更新する関数
            function updateButtons() {
                const currentIndex = $slider.slick('slickCurrentSlide');
                const slideCount = $slider.slick('getSlick').slideCount;
                // ボタンの状態と属性を設定
                const isPrevDisabled = currentIndex === 0;
                const isNextDisabled = currentIndex === slideCount - 1;
                $prevButton.prop('disabled', isPrevDisabled).attr('data-is-click', (!isPrevDisabled).toString());
                $nextButton.prop('disabled', isNextDisabled).attr('data-is-click', (!isNextDisabled).toString());
            }
            // 初期状態を設定
            updateButtons();
            // ボタンのクリックイベントを設定
            $prevButton.click(() => {
                $slider.slick('slickPrev');
            });
            $nextButton.click(() => {
                $slider.slick('slickNext');
            });
            // スライド変更時にボタンの状態を更新
            $slider.on('afterChange', () => {
                updateButtons();
            });
        });
    }
}
exports.Business = Business;
exports.default = Business;
